import { fetchList } from "api/function";
import {
  Box,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  FormControl,
  FormLabel,
  Select,
  Spinner,
} from "@chakra-ui/react";

const api_url = process.env.REACT_APP_API;

export default function BigQueryModal({
  openModal,
  modalLoading,
  handleFormSubmit,
  setOpenModal,
  selectedDataset,
  datasets,
  setSelectedDataset,
  setTableLoading,
  setTables,
  selectedTable,
  tableLoading,
  tables,
  setSelectedTable,
}) {
  return (
    <Modal isOpen={openModal} onClose={() => setOpenModal(false)} size="xl">
      <ModalOverlay />
      <ModalContent>
        {modalLoading ? (
          <Box
            p={4}
            display="flex"
            alignItems="center"
            justifyContent="center"
            h="30vh"
            bg="gray.200"
            rounded="lg"
            shadow="md"
          >
            <Spinner size="lg" color="blue.500" />
          </Box>
        ) : (
          <>
            <ModalHeader></ModalHeader>
            <ModalCloseButton />
            <form onSubmit={handleFormSubmit}>
              <ModalBody>
                <FormControl>
                  <FormLabel>Select Dataset</FormLabel>
                  <Select
                    placeholder="Select Dataset"
                    value={selectedDataset}
                    onChange={(e) => {
                      setSelectedDataset(e.target.value);
                      setTableLoading(true);
                      fetchList(
                        "",
                        `${api_url}/bigquery/datasets/${e.target.value}/tables`
                      )
                        .then((response) => {
                          setTables(response.tables);
                          setTableLoading(false);
                        })
                        .catch((error) => {
                          alert(error);
                        });
                      // Fetch and update the tables based on the selected dataset
                      // ...
                    }}
                  >
                    {datasets.map((data) => (
                      <option key={data.id} value={data.id}>
                        {data.id}
                      </option>
                    ))}
                  </Select>
                </FormControl>
                <FormControl mt={4}>
                  <FormLabel>Select Table</FormLabel>
                  <Select
                    placeholder="Select Table"
                    value={selectedTable}
                    onChange={(e) => setSelectedTable(e.target.value)}
                  >
                    {tableLoading ? (
                      <option>Loading...</option>
                    ) : tables.length !== 0 ? (
                      tables.map((data) => (
                        <option key={data.id} value={data.id}>
                          {data.id}
                        </option>
                      ))
                    ) : null}
                  </Select>
                </FormControl>
              </ModalBody>
              <ModalFooter>
                {selectedDataset && selectedTable && (
                  <Button type="submit" colorScheme="blue" mr={3}>
                    Add data to {selectedTable} table
                  </Button>
                )}
              </ModalFooter>
            </form>
          </>
        )}
      </ModalContent>
    </Modal>
    // <div
    //   id="staticModal"
    //   data-modal-backdrop="static"
    //   tabindex="-1"
    //   aria-hidden="true"
    //   class={`${
    //     openModal ? "" : "hidden"
    //   } fixed top-[12%] left-[25%] right-[10%] z-50  w-[50%] h-[80%] p-4 overflow-x-hidden overflow-y-auto  `}
    // >
    //   {modalLoading ? (
    //     <div className="w-full flex items-center justify-center h-[30vh] bg-card-backgroud-color rounded-lg shadow">
    //       <div class="text-center">
    //         <div role="status">
    //           <svg
    //             aria-hidden="true"
    //             class="inline w-8 h-8 mr-2 text-card-backgroud-color animate-spin  fill-button-color"
    //             viewBox="0 0 100 101"
    //             fill="none"
    //             xmlns="http://www.w3.org/2000/svg"
    //           >
    //             <path
    //               d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
    //               fill="currentColor"
    //             />
    //             <path
    //               d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
    //               fill="currentFill"
    //             />
    //           </svg>
    //           <span class="sr-only">Loading...</span>
    //         </div>
    //       </div>
    //     </div>
    //   ) : (
    //     <form
    //       onSubmit={handleFormSubmit}
    //       class="relative bg-card-backgroud-color rounded-lg shadow w-full"
    //     >
    //       <div class="flex items-start justify-between p-4 border-b border-color-text border-opacity-40 rounded-t ">
    //         <h3 class="text-xl font-semibold text-color-text ">
    //           Google Big Query
    //         </h3>
    //         <button
    //           onClick={() => {
    //             setOpenModal(!openModal);
    //           }}
    //           type="button"
    //           class="text-color-text bg-transparent hover:bg-gray-200 hover:text-color-text rounded-lg text-sm p-1.5 ml-auto inline-flex items-center "
    //           data-modal-hide="staticModal"
    //         >
    //           <svg
    //             class="w-5 h-5"
    //             fill="currentColor"
    //             viewBox="0 0 20 20"
    //             xmlns="http://www.w3.org/2000/svg"
    //           >
    //             <path
    //               fill-rule="evenodd"
    //               d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
    //               clip-rule="evenodd"
    //             ></path>
    //           </svg>
    //         </button>
    //       </div>
    //       <div class="p-6  w-full flex flex-row">
    //         <div className="w-[50%]  p-3">
    //           <label
    //             for="dataset"
    //             class="block mb-2 text-sm font-medium text-color-text "
    //           >
    //             Select Dataset
    //           </label>

    //           <button
    //             id="dropdownDividerButton"
    //             data-dropdown-toggle="dropdownDivider"
    //             class="text-white w-full cursor-pointer justify-between bg-color-text hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2.5 text-center inline-flex items-center "
    //             type="button"
    //           >
    //             {selectedDataset ? selectedDataset : "Select Dataset"}
    //             {/* <svg
    //                   class="w-4 h-4 ml-2"
    //                   aria-hidden="true"
    //                   fill="none"
    //                   stroke="currentColor"
    //                   viewBox="0 0 24 24"
    //                   xmlns="http://www.w3.org/2000/svg"
    //                 >
    //                   <path
    //                     stroke-linecap="round"
    //                     stroke-linejoin="round"
    //                     stroke-width="2"
    //                     d="M19 9l-7 7-7-7"
    //                   ></path>
    //                 </svg> */}
    //           </button>

    //           <div
    //             id="dropdownDivider"
    //             class="z-10 w-full cursor-pointer  bg-color-text mt-2 divide-y divide-gray-100 rounded-lg shadow "
    //           >
    //             <ul
    //               class="py-2 text-sm text-gray-700 dark:text-gray-200"
    //               aria-labelledby="dropdownDividerButton"
    //             >
    //               {datasets.map((data, index) => (
    //                 <li
    //                   onClick={() => {
    //                     setSelectedDataset(data.id);
    //                     setTableLoading(true);
    //                     fetchList(
    //                       "",
    //                       `http://127.0.0.1:5000/bigquery/datasets/${data.id}/tables`
    //                     )
    //                       .then((response) => {
    //                         setTables(response.tables);
    //                         setTableLoading(false);
    //                       })
    //                       .catch((error) => {
    //                         alert(error);
    //                       });
    //                   }}
    //                   className="hover:bg-[#D3D3D3]"
    //                 >
    //                   <a class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
    //                     {data.id}
    //                   </a>
    //                 </li>
    //               ))}
    //             </ul>
    //           </div>
    //         </div>

    //         <div className="w-[50%]  p-3">
    //           <label
    //             for="dataset"
    //             class="block mb-2 text-sm font-medium text-color-text "
    //           >
    //             Select Table
    //           </label>

    //           <button
    //             id="dropdownDividerButton"
    //             data-dropdown-toggle="dropdownDivider"
    //             class="text-white w-full cursor-pointer justify-between bg-color-text hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2.5 text-center inline-flex items-center "
    //             type="button"
    //           >
    //             {selectedTable ? selectedTable : "Select Table"}
    //           </button>
    //           {tableLoading ? (
    //             <div className="w-full h-full flex items-start mt-[10%] justify-center">
    //               <svg
    //                 aria-hidden="true"
    //                 class="w-8 h-8 mr-2 text-gray-200 animate-spin  fill-button-color"
    //                 viewBox="0 0 100 101"
    //                 fill="none"
    //                 xmlns="http://www.w3.org/2000/svg"
    //               >
    //                 <path
    //                   d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
    //                   fill="currentColor"
    //                 />
    //                 <path
    //                   d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
    //                   fill="currentFill"
    //                 />
    //               </svg>
    //             </div>
    //           ) : tables.length !== 0 ? (
    //             <div
    //               id="dropdownDivider"
    //               class="z-10 w-full cursor-pointer  bg-color-text mt-2 divide-y divide-gray-100 rounded-lg shadow "
    //             >
    //               <ul
    //                 class="py-2 text-sm text-gray-700 dark:text-gray-200"
    //                 aria-labelledby="dropdownDividerButton"
    //               >
    //                 {tables.map((data, index) => (
    //                   <li
    //                     onClick={() => {
    //                       setSelectedTable(data.id);
    //                     }}
    //                     className="hover:bg-[#D3D3D3]"
    //                   >
    //                     <a class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
    //                       {data.id}
    //                     </a>
    //                   </li>
    //                 ))}
    //               </ul>
    //             </div>
    //           ) : (
    //             <></>
    //           )}
    //         </div>
    //       </div>
    //       <div class="flex items-center p-6 space-x-2 border-t border-color-text border-opacity-40 rounded-b ">
    //         {selectedDataset && selectedTable ? (
    //           <button
    //             data-modal-hide="staticModal"
    //             type="submit"
    //             class="text-color-text bg-button-color hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
    //           >
    //             Add data to {selectedTable} table
    //           </button>
    //         ) : (
    //           <></>
    //         )}
    //       </div>
    //     </form>
    //   )}
    // </div>
  );
}
